<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Listado de ítems</h3>
            </div>
        </div>
        <div style="max-height: 300px" class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Cod. Barra</th>
                        <th>Ítem</th>
                        <th>Cantidad</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                        <td>
                            {{ item.codigo_barra }}
                        </td>
                        <td>
                            {{ item.nombre_item }}
                        </td>
                        <td>
                            {{ item.cantidad }}
                        </td>
                    </tr>
                    <tr v-show="items.length === 0">
                        <td colspan="3">
                            <strong>No se ha encontrado ítems.</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-buttons">
            <button type="button" @click="cerrar" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    methods: {
        cerrar: function () {
            this.$emit('cerrar');
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/VisorItemsAdicionales.vue